export default "__VITE_ASSET__CYtx$jX5__"